import { Trip } from "@/fetch/gworld";
import create from "zustand";
import { persist } from "zustand/middleware";

type SocialBannerState = {
  showSocialBanner: boolean | null | undefined;
  setShowSocialBanner: (current: boolean | null | undefined) => void;
};

const useSocialBannerStore = create(
  persist<SocialBannerState>(
    (set) => ({
      showSocialBanner: true,
      setShowSocialBanner: (showSocialBanner) => set({ showSocialBanner }),
    }),
    {
      name: "show-social-banner",
    }
  )
);

const useSocialBannerState = () => {
  const { showSocialBanner, setShowSocialBanner } = useSocialBannerStore();

  return { showSocialBanner, setShowSocialBanner };
};

export default useSocialBannerState;
